import React, { useEffect, useState } from "react";
import NetaqInput from "../components/NetaqInput";
import { Link } from "react-router-dom";
import { useTranslate } from "../components/TranslationText";
import Loader from '../components/Loader';
import axios from '../axios/axios';
import Lightbox from "react-18-image-lightbox";
import WahoCard from "../components/WahoCardImage";
import { useDispatch, useSelector } from "react-redux";
import Popup from "reactjs-popup";
import CompetitionsTab from "../components/CompetitionsTab";
import {
  incrementPageHorseCompetition,

} from "../Redux/StudBook/StudBookSlice";
import {
  FetchStudBookHorsePedigreeByIdthunk,
  FetchStudBookHorseCompetitionthunk,
} from "../Redux/StudBook/StudBookAction";
import ActionButton from "../components/ActionButton";
import HorseDetailsPedigreeChart from "../components/HorseDetailsPedigreeChart";
import HorseGallery from "../components/HorseGallery";
import PillBtn from "../components/PillBtn";
import NewActionButton from "../components/ActionButtons/NewActionButton";
import { serviceRequestHeadContainer, serviceRequestTitle, whiteCard } from "../common/cssclasses";
import CustomPopUp from "../components/CustomPopUp";

const BaseURL = process.env.REACT_APP_BASE_URL;
const umbracoBase = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

export default function WahoTrophy() {
  const { translate } = useTranslate();
  const [wahoList, setWahoList] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [errorFound, setErrorFound] = useState(false);

  const [year, setYear] = useState({
    label: translate('web.year', 'Year'),
    value: null,
  });

  const [isSettedBefore, setIsSettedBefore] = useState(false);

  const handleChange = (event) => {
    setYear(event);
    if (!isSettedBefore) {
      setIsSettedBefore(true);
    }
    return;
  };

  const currentlang = localStorage.getItem('eahsLang') ?? 'en';
  const [yearsList, setYearsList] = useState([]);

  // get waho List
  async function getWahoList(x = true) {
    try {
      const response = await axios.get(`/wahotrophy/list?year=${x && year.value != null ? year.value : 0}&lang=${currentlang}`);
      if (response.data.responseCode == "200") {
        if (response.data.result.length > 0) {
          setWahoList(response.data.result.sort((b, a) => a.year - b.year));
          setLoaded(true);
        }
        else {
          setWahoList(response.data.result);
          setLoaded(true);
        }
        const formattedYearslist = response.data.result.map((item) => ({ text: item.year, value: item.year }));
        if (!isSettedBefore) {
          setYearsList(formattedYearslist);
        }
      } else {
        console.log('error in getting waho trophy');
        setLoaded(true);
        setErrorFound(true);
      }
    } catch (error) {
      console.log('error in getting waho trophy');
      setLoaded(true);
      setErrorFound(true);
    }
  }

  useEffect(() => {
    if (!!year) {
      getWahoList();
    } else {
      getWahoList(false);
    }
  }, [year]);

  // light Box
  const [imageslightbox, setImageslightbox] = useState([]);
  const [index, setIndex] = useState(-1);

  const currentImage = imageslightbox[index];
  const nextIndex = (index + 1) % imageslightbox.length;
  const nextImage = imageslightbox[nextIndex] || currentImage;
  const prevIndex = (index + imageslightbox.length - 1) % imageslightbox.length;
  const prevImage = imageslightbox[prevIndex] || currentImage;

  const handleClick = (clickedIndex, albumMedia, isBase64 = false) => {
    const allImages = wahoList.map((item) =>
      isBase64 ? albumMedia : `${umbracoBase}${albumMedia}`
    );

    setImageslightbox(allImages);
    setIndex(clickedIndex);
  };

  const handleClose = () => setIndex(-1);

  // compititions
  const {

    studBookHorseCompetitionData,
    takeHorseCompetition,
    pageHorseCompetition,
    totalCountHorseCompetition,
    studBookPedigreeData
  } = useSelector((state) => state.studBookSlice);

  const dispatch = useDispatch();

  const handlePageChangeHorseCompetition = (page) => {
    dispatch(incrementPageHorseCompetition(page));
  };

  const paginiateStyle = {
    width: 36,
    height: 36,
    background: "#E44D52",
    display: "inline-block",
    lineHeight: "37px",
    color: "#fff",
    cursor: "pointer",
    margin: 5,
    borderRadius: 8,
  };
  const pagenumberStyle = {
    ...paginiateStyle,
    width: 36,
    height: 36,
    background: "#ffffff",
    display: "inline-block",
    lineHeight: "37px",
    color: "black",
    cursor: "pointer",
    margin: 5,
    borderRadius: 8,
    borderColor: "#c0cedd",
    borderStyle: "solid",
  };

  const renderPaginationHorseCompetition = () => {
    const pages = [];

    const numPages = Math.ceil(
      totalCountHorseCompetition / takeHorseCompetition
    );

    for (let i = 1; i <= numPages; i++) {
      pages.push(
        <React.Fragment>
          <span
            key={i}
            style={{
              ...pagenumberStyle,
              background:
                i === pageHorseCompetition
                  ? "rgba(0, 0, 0)"
                  : pagenumberStyle.background,
              color:
                i === pageHorseCompetition ? "white" : pagenumberStyle.color,
            }}
            onClick={() => handlePageChangeHorseCompetition(i)}
          >
            {i}
          </span>
        </React.Fragment>
      );
    }

    let _pages = [];

    if (pages.length >= 5 && pageHorseCompetition === 1) {
      _pages = pages
        .slice(pageHorseCompetition - 1, 3)
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (pageHorseCompetition > 1) {
      _pages = pages.slice(pageHorseCompetition);
    }
    if (pageHorseCompetition > 1 && numPages - pageHorseCompetition > 3) {
      _pages = pages
        .slice(pageHorseCompetition - 1, pageHorseCompetition)
        .concat(_pages.slice(0, 2))
        .concat(<span>...</span>)
        .concat(pages.slice(-1));
    }

    if (pageHorseCompetition === 1 && numPages - pageHorseCompetition <= 3) {
      _pages = pages;
      if (studBookHorseCompetitionData.length === 0) {
        _pages = [];
      }
    }

    if (pageHorseCompetition > 1 && numPages - pageHorseCompetition <= 3) {
      _pages = pages
        .slice(pageHorseCompetition - 1, pageHorseCompetition)
        .concat(_pages.slice(0, 3));
    }

    return _pages;
  };

  // end of compitiitns


  return (
    <>
      {loaded && wahoList.length > 0 ? (
        <>
          {errorFound && (
            <div className="row rtl text-danger">
              {translate('web.errorInGettingData', 'Error in getting Data')}
            </div>
          )}
          <div className={'row rtl'}>
            <h2 className={serviceRequestTitle} >
              {translate('web.theWahoTrophy', 'The Waho Trophy')}
            </h2>
            {yearsList.length > 0 && (
              <div className='col-lg-3 col-md-3 col-sm-12 mb-main ms-auto' >
                <NetaqInput
                  isClearable={true}
                  type={'select'}
                  name={'year'}
                  label={translate('web.year', 'Year')}
                  placeholder={translate('web.year', 'Year')}
                  listSelect={yearsList}
                  value={year}
                  hideLable={true}
                  onChange={handleChange}
                />
              </div>
            )}
          </div>

          <div className='row  rtl'>
            {wahoList.map((item, index) => (
              <div className='col-lg-4 col-md-6  col-sm-12 col-12 mb-main'>
                <div className={whiteCard}>
                  <div className="w-100 border-15 mb-form-group overflow-hidden" style={{ maxHeight: 150 }}>
                    <img
                      className='w-100 border-15'
                      onClick={() => handleClick(index, [item.image])}
                      src={`${umbracoBase}${item.image}`}
                      alt='Waho Trophy'
                    />
                  </div>
                  <div>
                    <div className='horseCardTitle'>{item.year} : {item.name} - {item.registerNo}</div>
                    <div className='horseCardTitle text-secondary '>{item.subTitle}</div>
                    <div className='horseCardDescription mb-form-group noMarginBottomForP' dangerouslySetInnerHTML={{ __html: item.description }} />

                  </div>
                  <div className="row">
                    {!!item.certificate &&
                      <div className="col-6 mb-form-group">
                        <PillBtn
                          isSubmitBtn
                          isNoAction
                          isNoPadding
                          isNoMargin
                          isWithClass
                          classes="btn-light bg-offWhite"
                          text={translate('web.showCertificate', 'Show Certificate')}
                          onClick={() => handleClick(index, [item.certificate])}
                        />
                      </div>
                    }

                    <CustomPopUp
                      onOpen={(e) => {
                        e.preventDefault();
                        let paramsHorseCompetition = {
                          id: item.id,
                          skip: (pageHorseCompetition - 1) * takeHorseCompetition,
                          take: takeHorseCompetition,
                          langauge: currentlang,
                        };
                        dispatch(FetchStudBookHorseCompetitionthunk(paramsHorseCompetition));
                      }}
                      trigger={
                        <div className="col-6  mb-form-group">

                          <PillBtn
                            isNoAction
                            isRed
                            isNoPadding
                            isNoMargin
                            text={translate('web.results', 'Results')}
                          />
                        </div>
                      }
                      content={<>
                        <CompetitionsTab
                          studBookHorseCompetitionData={studBookHorseCompetitionData}
                          translate={translate}
                          pageHorseCompetition={pageHorseCompetition}
                          handlePageChangeHorseCompetition={handlePageChangeHorseCompetition}
                          renderPaginationHorseCompetition={renderPaginationHorseCompetition}
                          totalCountHorseCompetition={totalCountHorseCompetition}
                          takeHorseCompetition={takeHorseCompetition}
                          isPopUp
                        />
                      </>}
                    />


                    <CustomPopUp
                      title={translate("web.pedigree", "Pedigree")}
                      onOpen={(e) => {
                        e.preventDefault();
                        let paramsHorsePedigree = {
                          id: item.id,
                          langauge: currentlang,
                        };
                        dispatch(FetchStudBookHorsePedigreeByIdthunk(paramsHorsePedigree));

                      }}
                      trigger={
                        <div className="col-6  ">
                          <PillBtn
                            isNoAction
                            isNoPadding
                            isNoMargin
                            text={translate("web.pedigree", "Pedigree")}
                          />
                        </div>
                      }
                      content={
                        <HorseDetailsPedigreeChart hierarchy={studBookPedigreeData} />
                      }
                    />


                    {!!item.horseGallery &&
                      <>
                        <CustomPopUp
                          title={translate("web.mediaGallery", "Media Gallery")}
                          trigger={
                            <div className="col-6  ">
                              <PillBtn
                                isNoAction
                                isRed
                                isNoPadding
                                isNoMargin
                                text={translate("web.mediaGallery", "Media Gallery")}
                              />
                            </div>
                          }
                          content={<HorseGallery data={item.horseGallery} />}
                        />

                      </>
                    }
                  </div>
                </div>
              </div>
            ))}
          </div>
          {!!currentImage && (
            <Lightbox
              wrapperClassName='ltr'
              mainSrc={imageslightbox[index]}
              onCloseRequest={handleClose}
            />
          )}
        </>
      ) : (
        <Loader />
      )}
    </>
  );
}

